import React from 'react';
import { Table } from 'reactstrap';

export const RuDiagramModal = ({ title, content }) => ({
  title,
  body: (
    <div>
      {content}
      <Table size="sm">
        <tbody>
          <tr>
            <th scope="row">1</th>
            <td>Water height - Eyewitness observation - the maximum elevation the wave.</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>Tide Gauge - half of the maximum height (minus the normal tide)of a tsunami wave recorded at the coast by a tide gauge. Also called the amplitude.</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>Deep Ocean Gauge - half of the maximum height (minus the normal tide) of a tsunami wave recorded in the open ocean by a seafloor bottom pressure recording system.</td>
          </tr>
          <tr>
            <th scope="row">4</th>
            <td>Water height (Post-tsunami survey measurement) - the maximum elevation the wave.</td>
          </tr>
          <tr>
            <th scope="row">5</th>
            <td>Runup Height (Post-tsunami survey measurement) - the maximum elevation the wave reaches at the maximum inundation.</td>
          </tr>
          <tr>
            <th scope="row">8</th>
            <td>Runup Height in Harbor (Post-tsunami survey measurement) - water height in the harbor.</td>
          </tr>
          <tr>
            <th scope="row">10</th>
            <td>Flow Depth (Post-tsunami survey measurement) depth of the water.</td>
          </tr>
          <tr>
            <th scope="row">9</th>
            <td>Splash mark (Post-tsunami survey measurement)</td>
          </tr>
          <tr>
            <th scope="row">6</th>
            <td>Atmospheric Wave - Tsunami-like phenomena generated by meteorological or atmospheric disturbances. These waves can be produced by atmospheric gravity waves, pressure jumps, frontal passages, squalls, gales, typhoons, hurricanes and other atmospheric sources. Meteotsunamis have the same temporal and spatial scales as tsunami waves and can similarly devastate coastal areas, especially in bays and inlets with strong amplification and well-defined resonant properties. Sometimes referred to as rissaga. The water height definition for an atmospheric wave depends on whether it was measured by a tide gauge (2), eyewitness (1), or field survey (4,5).</td>
          </tr>
          <tr>
            <th scope="row">7</th>
            <td>Seiche - A standing wave oscillating in a partially or fully enclosed body of water. It may be initiated by long period seismic waves (an earthquake), wind and water waves, or a tsunami. The water height definition for a seiche depends on whether it was measured by a tide gauge (2), eyewitness (1), or field survey (4,5).</td>
          </tr>
        </tbody>
      </Table>
      <br />

      <img src="https://www.ngdc.noaa.gov/hazard/img/IOC_37_figV3.jpg" width="467" height="142" alt="runup diagram" />
      <br />
      Figure V.3. Tsunami hydrodynamic data terminology.
      <i>From the UNESCO-IOC Post Tsunami Survey Field Guide, 2nd edition, IOC Manuals and Guides No. 37, p. 48</i>
      :
      <br />
      <br />
      <p>
        A number of terms are used to describe the overland flow of the tsunami (Figure V.3). It is essential to use the appropriate term for the types of measurements used. Important quantities include the
        {' '}
        <b>tsunami flow depth</b>
        {' '}
        (code 10),
        {' '}
        {' '}
        <b>tsunami height</b>
        {' '}
        (code 4), the
        {' '}
        <b>runup height</b>
        {' '}
        (code 5) and the inundation distance. Runup is the maximum ground elevation wetted by the tsunami on a sloping shoreline. In the simplest case, the runup value is recorded at the maximum inundation distance - the horizontal distance flooded by the wave. Flow depth is the depth of the tsunami flood over the local terrain height while the tsunami height is the total elevation of the water free surface above a reference datum. In some cases where the ground topography is flat, large tsunamis can penetrate for hundreds of metres, and several kilometres inland. In such cases it may not be practical to quantitatively measure inundation distances to the furthest inland extent. In such cases, it is most useful to estimate the tsunami height and flow depths close to the shoreline and as far inland as the conditions and circumstances allow.
      </p>
    </div>
  ),
});
